import { Component, Input } from '@angular/core';

@Component({
  selector: 'ist-margin',
  templateUrl: './ist-margin.component.html',
  styleUrls: ['./ist-margin.component.scss']
})
export class IstMarginComponent {

  @Input() revenue: number;
  @Input() fieldValue: number;
  @Input() selectedMonth: number = 1;
  @Input() lastHistoricalMonth: number = 1;
  @Input() isForecastedYear: boolean = false;
  @Input() isWeightingPage: boolean = false;

  /** Calculate % value and return it to display */
  get displayValue(): number {
    if(!this.fieldValue || !this.revenue){
      return 0.0;
    }else {
      if (isNaN(this.fieldValue))
        this.fieldValue = Number(this.fieldValue.toString().replace(/,/g, ''));

      if (isNaN(this.revenue))
        this.revenue = Number(this.revenue.toString().replace(/,/g, ''));

      let percent: number;

      if (this.isForecastedYear) { // for Forecasted Year of income statement table page percentage
        // percent = Math.abs(this.round(((Number(this.revenue) * 100) / Number(this.fieldValue)) - 100 , 1));
        const fieldValueDiv = this.fieldValue / this.lastHistoricalMonth;
        const revenueDiv = this.revenue / this.selectedMonth;
        percent = this.round(((Number(revenueDiv) * 100) / Number(fieldValueDiv)) - 100, 1);
      } else if (this.isWeightingPage) { // for weighting page percentage
        // percent = Math.abs(this.round(((Number(this.fieldValue) - Number(this.revenue)) / Number(this.revenue)) * 100, 1));
        percent = this.round(((Number(this.fieldValue) - Number(this.revenue)) / Number(this.revenue)) * 100, 1);
      } else { // for Historical year of income statement table page percentage
        // percent = Math.abs(this.round(Number(this.fieldValue) / Number(this.revenue) * 100, 1));
        const fieldValueDiv = this.fieldValue / this.selectedMonth;
        const revenueDiv = this.revenue / this.selectedMonth;
        percent = this.round(Number(fieldValueDiv) / Number(revenueDiv) * 100, 1);
      }

      // if(percent > 999)
      //   return Number('>999');
      // else 
        return Number(percent.toFixed(1));
    }
  }

  /** Round the given value based on precision */
  round(value, precision): number {
    let multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

}
